import React from 'react'

// material-ui
import Box from '@mui/material/Box'
import Container from '@mui/material/Container'

// components
import Link from '@mui/material/Link'
// import Typography from '@mui/material/Typography'
import DesktopHeader from 'components/shared/LogoHeader/DesktopHeader'

const ScheduleDesktopHeader = props => {
  const { title, learnMoreText, learnMoreLink, logInText, logInLink } = props

  return (
    <>
      <DesktopHeader title={title} />

      <Container>
        <Box align='right'>
          <Link variant='body1' target='_blank' href={learnMoreLink}>
            {learnMoreText}
          </Link>
          <Link ml={2} variant='body1' align='right' href={logInLink}>
            {logInText}
          </Link>
        </Box>
      </Container>
    </>
  )
}

export default ScheduleDesktopHeader
